import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import QueryString from 'qs';
import store from '@/store';
import { AUTH_LOGOUT } from '@/store/auth';

export const AUTH_TOKEN_KEY = 'token';

Axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default class Http {
  public axios = Axios;
  protected addUrl?: string;

  constructor (addUrl?:string) {
    this.addUrl = addUrl || '';
    if (localStorage.getItem(AUTH_TOKEN_KEY)) {
      this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY);
    }
    this.authCheck();
  }

  protected authCheck () {
    // Logout if response error code = 401
    this.axios.interceptors.response.use(response => response,
      (error) => {
        if (error.response.status === 401) {
          localStorage.removeItem(AUTH_TOKEN_KEY);
          window.location.assign('/');
        }
        return Promise.reject(error.response);
      });
  }

  public request<T = any, R = AxiosResponse<T>> (config: AxiosRequestConfig) {
    if (this.addUrl) {
      if (config.url) {
        config.url = this.addUrl + config.url;
      } else {
        config.url = this.addUrl;
      }
    }
    if (config.params) {
      config.paramsSerializer = function (params:any) {
        return QueryString.stringify(params, { arrayFormat: 'indices' });
      };
    }
    return this.axios.request<T>(config);
  }
  public post<T = any, R = AxiosResponse<T>> (config: AxiosRequestConfig) {
    config.method = 'POST';
    return this.request(config);
  }
  public delete<T = any, R = AxiosResponse<T>> (config: AxiosRequestConfig) {
    config.method = 'DELETE';
    return this.request(config);
  }
  public arrayBuffer<T = any, R = AxiosResponse<T>> (config: AxiosRequestConfig) {
    config.method = 'get';
    config.responseType = 'arraybuffer';
    return this.request(config);
  }
}
